import script from "./CollectiviteMembrePlan.vue?vue&type=script&setup=true&lang=ts"
export * from "./CollectiviteMembrePlan.vue?vue&type=script&setup=true&lang=ts"

import "./CollectiviteMembrePlan.vue?vue&type=style&index=0&id=478d5e62&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-478d5e62"]])

export default __exports__